import React from 'react';
import propTypes from 'prop-types';
import Select from 'react-select';
import debounce from 'debounce-promise';

import api from '../../../../utils/Api';
import { AUTH_TOKEN_KEY } from '../../../../constants';

class SelectUserAsync extends React.Component{
  constructor(props){
    super(props);
    this.loadSelectOptions = this.loadSelectOptions.bind(this);
    this._loadOptions = this._loadOptions.bind(this);
    this._debouncedLoadOptions = debounce(this._loadOptions, 800);
  }

  componentWillUnmount() {
    if (this._debouncedLoadOptions.cancel) {
      this._debouncedLoadOptions.cancel();
    }
  }

  loadSelectOptions(input){
    return this.refs[this.props.id].loadOptions(input);
  }

  _loadOptions(input){
    const myToken = localStorage.getItem(AUTH_TOKEN_KEY);
    const headers = {
      'Authorization': `Bearer ${myToken}`
    };
    const params = {
      keyword: input,
      ...this.props.paramsApi
    }
    return api(headers).get('/admins/users', { params })
    .then(({ data }) => {
      const products = data.data.data.map(item=>{
        if(item.id === this.props.userId){
          return { id: item.id, email: `${item.email} (You)` }
        }
        return {
          id: item.id,
          email: item.email
        }
      })
      if(this.props.onSelectSearch){
        this.props.onSelectSearch(input)
      }
      return { options: products };
    });
  }

  render(){
    return(
      <div>
        {
          this.props.create?(
            <Select.AsyncCreatable
              valueKey="id"
              labelKey="email"
              ref={this.props.id}
              defaultOptions
              loadOptions={this._debouncedLoadOptions}
              cacheOptions={this.props.cacheOptions}
              id={this.props.id}
              name={this.props.name}
              value={this.props.value}
              placeholder={this.props.placeholder}
              noResultsText={this.props.noResultsText}
              onChange={this.props.onSelectChange}
              // onOpen={this.props.onSelectOpen}
              disabled={this.props.isDisabled}
              multi={this.props.isMulti}
            />
          ):(
            <Select.Async
              valueKey="id"
              labelKey="email"
              ref={this.props.id}
              defaultOptions
              loadOptions={this._debouncedLoadOptions}
              cacheOptions={this.props.cacheOptions}
              id={this.props.id}
              name={this.props.name}
              value={this.props.value}
              placeholder={this.props.placeholder}
              noResultsText={this.props.noResultsText}
              onChange={this.props.onSelectChange}
              onOpen={this.props.onSelectOpen}
              disabled={this.props.isDisabled}
              multi={this.props.isMulti}
            />
          )
        }
      </div>
    )
  }
}

export default SelectUserAsync;

SelectUserAsync.defaultProps = {
  cacheOptions: false,
  value: null,
  placeholder: 'Select a user...',
  noResultsText: 'No Result!',
  paramsApi: {},
  userId: 0
}

SelectUserAsync.propTypes = {
  id: propTypes.string.isRequired,
  name: propTypes.string,
  userId: propTypes.number,
  value: propTypes.oneOfType([propTypes.object, propTypes.array]),
  placeholder: propTypes.string,
  noResultsText: propTypes.string,
  cacheOptions: propTypes.bool,
  paramsApi: propTypes.object,
  onSelectSearch: propTypes.func,
  onSelectChange: propTypes.func,
  onSelectOpen: propTypes.func,
  isMulti: propTypes.bool,
  isDisabled: propTypes.bool,
}